import Actions from "./actions";

// Required to Notify user when the user receives notification
const notificationReceivedListener = (message) => {
  return (dispatch) => {
    dispatch(Actions.receivedNotification(message));
  };
};
const newNotificationsListener = (message) => {
  return (dispatch) => {
    dispatch(Actions.newNotifications(message));
  };
};
const loadNewNotificationsListener = (message) => {
  return (dispatch) => {
    dispatch(Actions.loadNewNotifications(message));
  };
};
const huddleWidgetListener = (payload) => {
  return (dispatch) => {
    dispatch(
      Actions.setShowHuddleNotification({
        show: true,
        data: payload,
      })
    );
  };
};

const kickUserNotificationListener = (payload) => {
  return (dispatch) => {
    dispatch(
      Actions.setShowKickNotification({
        show: true,
        data: payload,
      })
    );
  };
};

export const NotificationListeners = {
  notificationReceived: notificationReceivedListener,
  newNotifications: newNotificationsListener,
  loadNewNotifications: loadNewNotificationsListener,
  huddleWidgetNotification: huddleWidgetListener,
  kickUserNotification: kickUserNotificationListener,
};
